<template>
    <modal :id="ref" :ref="ref" :closeProp="close" :title="fullTitle" xlarge>
        <div v-if="!!error" class="alert alert-danger show" role="alert">
            <span class="alert-icon">
                <font-awesome-icon
                    :icon="['fad', 'exclamation']"
                ></font-awesome-icon>
            </span>

            <h3 class="alert-heading headline-font">Errore</h3>
            <ul v-if="typeof error === 'array' || typeof error === 'object'">
                <li
                    v-for="(value, key) in error"
                    :key="key"
                    v-html="value"
                ></li>
            </ul>
            <p v-else-if="typeof error === 'string'" v-html="error"></p>
        </div>

        <div class="row">
            <div class="col-md-6">
                <form :id="refForm" :ref="refForm">
                    <map-autocomplete-single
                        id="parking_autocomplete"
                        label="Indirizzo"
                        mapRef="parkingMap"
                        @placeSelected="addMarkerToMap"
                        @placeCleared="clearMarkersFromMap"
                        :pos="autocompleteData"
                    />
                    <form-textarea
                        label="Note"
                        id="notes"
                        name="notes"
                        :value="getValue('notes')"
                    ></form-textarea>
                </form>
            </div>
            <div class="col-md-6">
                <google-map
                    ref="parkingMap"
                    id="parking_map"
                    :height="400"
                    :center="true"
                    @map-ready="initMapMarkers"
                />
            </div>
        </div>
        <template v-slot:footer>
            <btn
                type="success"
                :icon="['fad', 'check']"
                title="Salva"
                :action="submitForm"
            ></btn>
        </template>
    </modal>
</template>

<script>
export default {
    data: () => ({
        ref: "parking",
        title: "Parcheggio",
        refForm: "",
        urlupdate: "",
        id: "",
        datas: {},
        error: null
    }),
    props: {
        urlstore: {
            type: String,
            default: "",
            required: true
        },
        reftable: {
            type: String,
            default: "",
            required: false
        },
        refMap: {
            type: String,
            default: "",
            required: false
        }
    },
    computed: {
        fullTitle: function() {
            return !!this.id ? "Modifica " + this.title : "Crea " + this.title;
        },
        autocompleteData: function() {
            if (!this.emptyObject(this.datas)) {
                return {
                    address: this.datas.address,
                    lat: this.datas.latitude,
                    lng: this.datas.longitude,
                    notes: this.datas.notes
                };
            }
            return null;
        }
    },
    methods: {
        close: function() {
            this.assignData({});
            this.urlupdate = "";
            this.error = null;
            this.id = "";

            this.$refs[this.ref].close();
        },
        open: function(data) {
            if (!!data && typeof data === "object") {
                if (!!data.urlupdate) this.urlupdate = data.urlupdate;
                if (!!data.datas) this.assignData(data.datas);
            } else if (!!data && Array.isArray(data)) {
                this.assignData(data);
            } else {
                this.assignData({});
            }
            this.$refs[this.ref].open();
        },
        canEdit: function() {
            return !this.datas["id_crm"];
        },
        getValue: function(key, defaultValue) {
            if (!!this.datas[key]) return this.datas[key];
            else if (!!defaultValue) return defaultValue;
            else return "";
        },
        getAction: function() {
            return !!this.id ? this.urlupdate : this.urlstore;
        },
        getMethod: function() {
            return !!this.id ? "PATCH" : "POST";
        },
        assignData: function(datas) {
            if (!datas) return false;
            if (!!Object.keys(datas).length) {
                this.datas = datas;
                if (!!datas.id) this.id = datas.id;
            } else {
                this.datas = {};
                this.id = "";
            }
        },
        submitForm: function() {
            this.error = null;

            return this.$root.request(
                this,
                this.getAction(),
                this.getMethod(),
                this.$root.getParamsFromForm(this.$refs[this.refForm]),
                this.submitFormCallback,
                this.errorFormCallback
            );
        },
        submitFormCallback: function(data) {
            if (!!this.reftable) this.$root.tableRefresh(this.reftable);
            try {
                if (!!this.refMap)
                    this.$root.$refs[this.refMap].refreshMarkers();
            } catch (ex) {
                console.log(ex);
            }

            let self = this;
            Vue.nextTick().then(function() {
                self.close();
            });
        },
        errorFormCallback: function({ response, message }) {
            if (!!response.data && !!response.data.error)
                this.error = response.data.error;
            else this.error = null;
        },
        addMarkerToMap: function(position) {
            this.$refs["parkingMap"].addMarker("parking", position);
        },
        clearMarkersFromMap: function() {
            this.$refs["parkingMap"].removeMarker("parking");
        },
        initMapMarkers: function() {
            if (!!this.autocompleteData) {
                this.addMarkerToMap(this.autocompleteData);
            }
        }
    },
    created: function() {
        this.refForm = this.ref + "DataForm";
    },
    mounted: function() {}
};
</script>
